import { ServerErrorCode } from './server-error-code';

export class ServerErrorDto {
  errorCode!: ServerErrorCode;
  errorDescription!: string;
}
